import React from 'react';
import {
  List,
  Datagrid,
  TextInput,
  DateField,
  TextField,
  Filter,
  ReferenceInput,
  SelectInput,
  ShowButton,
  ReferenceField,
  FunctionField,
} from 'react-admin';
import _ from 'lodash';

// import CustomExportButton from '../CustomExportButton';
// import { modelFields, automaticallySelectedFields, transformDataForExportFn } from './constants';
import {
  offeringCategory,
  offeringInterestIndicationStatuses,
} from '../../helpers/mappings';

const OfferWatchFilter = props => (
  <Filter {...props}>
    <ReferenceInput
      label="Offer"
      source="offerId"
      reference="offerings"
      alwaysOn
      perPage={100}
    >
      <SelectInput
        optionText={choice => `${choice.name} (${_.values(offeringCategory).find(item => item.value === choice.category).label})`}
      />
    </ReferenceInput>
    <TextInput label="Email or Name" source="_OMNI_" alwaysOn />
  </Filter>
);

// const ListActions = (props) => {
//   const {
//     currentSort, filterValues, total, resource,
//   } = props;
//   return (
//     <div>
//       <CustomExportButton
//         filter={filterValues}
//         sort={currentSort}
//         total={total}
//         resource={resource}
//         exportTitle="Indications of Interest - Export"
//         modelFields={modelFields}
//         automaticallySelectedFields={automaticallySelectedFields}
//         transformFn={transformDataForExportFn}
//       />
//     </div>
//   );
// };

export default props => (
  <List
    {...props}
    bulkActionButtons={false}
    filters={<OfferWatchFilter />}
    title="Offer Indications of Interest"
    // actions={<ListActions />}
  >
    <Datagrid>
      <ReferenceField label="Offer" source="offerId" reference="offerings" linkType sortable={false}>
        <TextField source="name" />
      </ReferenceField>
      <TextField label="First Name" source="subscriberPersonalData.firstName" sortable />
      <TextField label="Last Name" source="subscriberPersonalData.lastName" sortable />
      <TextField label="Email" source="subscriberPersonalData.email" sortable />
      <TextField label="Phone Number" source="subscriberPersonalData.phoneNumber" sortable />
      <TextField label="State Of Residence" source="subscriberPersonalData.stateOfResidence" sortable />
      <TextField label="Investment Range" source="subscriberInvestmentRange" sortable />
      <FunctionField
        label="Indication Status"
        render={record => `${record.status === offeringInterestIndicationStatuses.WATCHING ? 'Indicated' : 'Cancelled Indication'}`}
      />
      <DateField source="createdAt" sortable />
      <ShowButton />
    </Datagrid>
  </List>
);



// WEBPACK FOOTER //
// ./src/components/OfferWatch/List.js